const gettext = (s) => s;
export default gettext;



// WEBPACK FOOTER //
// ./src/holding/i18n/gettext.ts